import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import mapModule from './modules/map'
import dataExportModule from './modules/data-exports'
import chartModule from './modules/chart'
import mainMenuModule from './modules/main-menu'
Vue.use(Vuex)

export const store = new Vuex.Store({
  namespaced: true,
  modules: {
    mapModule: mapModule,
    dataExportModule: dataExportModule,
    chartModule: chartModule,
    mainMenuModule: mainMenuModule
  },
  state: {
    zoom: 3,
    zoomRange: [0, 19],
    settingsPool: [],
    localSettings: [],
    filtersPool: [],
    localFilters: [],
    translations: [],
    filtersRequired: false,
    extraMenuSelected: '',
    printData: null
  },
  mutations: {
    UPDATE_ZOOM (state, zoom) {
      state.zoom = zoom
    },
    UPDATE_ZOOM_RANGE (state, zoomRange) {
      state.zoomRange = zoomRange
    },
    UPDATE_SETTINGS_POOL (state, settingsPool) {
      state.settingsPool = settingsPool
    },
    UPDATE_FILTERS_POOL (state, filtersPool) {
      state.filtersPool = filtersPool
    },
    UPDATE_LOCAL_SETTINGS (state, localSettings) {
      state.localSettings = []
      state.localSettings = localSettings
    },
    UPDATE_LOCAL_FILTERS (state, localFilters) {
      state.localFilters = []
      state.localFilters = localFilters
    },
    UPDATE_TRANSLATIONS (state, translations) {
      state.translations = translations
    },
    UPDATE_FILTERS_REQUIRED (state, value) {
      state.filtersRequired = value
    },
    UPDATE_EXTRAMENU_SELECTED (state, value) {
      state.extraMenuSelected = value
      // console.log(state.extraMenuSelected)
    },
    SET_PRINT_DATA (state, value) {
      state.printData = value
      // console.log(state.extraMenuSelected)
    }
  },
  actions: {
    async loadSettingsPool (context, url) {
      try {
        const response = await axios.get(url, { baseURL: this.getters.baseURL })
        context.commit('UPDATE_SETTINGS_POOL', response.data)
      } catch (e) {
        console.error(e)
      }
    },
    async loadFiltersPool (context, url) {
      try {
        const response = await axios.get(url, { baseURL: this.getters.baseURL })
        context.commit('UPDATE_FILTERS_POOL', response.data)
      } catch (e) {
        console.error(e)
      }
    },
    async loadLocalSettings (context, url) {
      try {
        const response = await axios.get(url, { baseURL: this.getters.baseURL })
        context.commit('UPDATE_LOCAL_SETTINGS', response.data)
        return response
      } catch (e) {
        console.error(e)
      }
    },
    async loadLocalFilters (context, url) {
      try {
        const response = await axios.get(url, { baseURL: this.getters.baseURL })
        context.commit('UPDATE_LOCAL_FILTERS', response.data)
        return response
      } catch (e) {
        console.error(e)
      }
    },
    async loadTranslations (context, url) {
      try {
        const response = await axios.get(url, { baseURL: this.getters.baseURL })
        context.commit('UPDATE_TRANSLATIONS', response.data)
      } catch (e) {
        console.error(e)
      }
    },
    setFiltersRequired (context, value) {
      context.commit('UPDATE_FILTERS_REQUIRED', value)
    },
    setExtraMenuSelected (context, value) {
      context.commit('UPDATE_EXTRAMENU_SELECTED', value)
    },
    setPrintData (context, value) {
      context.commit('SET_PRINT_DATA', value)
    }
  },
  getters: {
    zoom: state => state.zoom,
    zoomRange: state => state.zoomRange,
    settingsPool: state => state.settingsPool,
    filtersPool: state => state.filtersPool,
    localSettings: state => state.localSettings,
    localFilters: state => state.localFilters,
    translations: state => state.translations,
    filtersRequired: state => state.filtersRequired,
    baseURL: function (state) {
      let baseURL
      // if (state.extraMenuSelected && state.extraMenuSelected !== 'gmp3') {
      //   baseURL = state.mainMenuModule.rootAPIEnv1 + state.extraMenuSelected.replace('_', '-') + state.mainMenuModule.rootAPIEnv2
      // } else {
      baseURL = state.mainMenuModule.rootAPI
      // }
      return baseURL
    },
    printData: state => state.printData
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js